import { getOrigin, getOriginLabel, getOriginUrl } from '@/requests/requestOrigin.utilities';
import { SeeqNames } from '@seeqdev/constants';
import type { SeeqInternalAxiosRequestConfig } from '@/requests/axios.utilities';
import type { WorkbenchStore } from '@/workbench/workbench.store';
import type { WorkbookStore } from '@/workbook/workbook.store';

export function createRequestOriginInterceptor(workbenchStore: WorkbenchStore, workbookStore: WorkbookStore) {
  return function requestOriginInterceptor(config: SeeqInternalAxiosRequestConfig) {
    if (config.headers) {
      const { originURL, originLabel, worksheetId, workbookId } = workbenchStore.stateParams;
      const { isTopic, isVantage, isAnalysis } = workbookStore;
      const origin = getOrigin({ isTopic, isVantage, isAnalysis });
      const url = getOriginUrl({ originURL, workbookId, worksheetId });
      const label = getOriginLabel({
        originLabel,
        workbookName: workbookStore.name,
        worksheetName: workbookStore.getWorksheetName(worksheetId),
        isLocked: workbookStore.isLocked,
      });

      config.headers[SeeqNames.API.Headers.RequestOrigin] = origin;
      config.headers[SeeqNames.API.Headers.RequestOriginURL] = url;
      config.headers[SeeqNames.API.Headers.RequestOriginLabel] = label;
    }
    return config;
  };
}
